"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasCheckingAccountFiltersLoadedSuccessfully = exports.getHasACheckingAccountFiltersFetchFinished = exports.getCheckingAccountFiltersSlice = exports.getCheckingAccountFiltersLastSuccess = exports.getCheckingAccountFiltersLastError = exports.getCheckingAccountFiltersError = exports.getCheckingAccountFiltersData = exports.getCheckingAccountFilters = exports.getAreCheckingAccountFiltersLoading = exports["default"] = exports.checkingAccountFilters = void 0;

var _reselect = require("reselect");

var _utils = require("@navinc/utils");

var _actions = require("./actions.js");

var checkingAccountFilters = (0, _utils.createFetchReducer)({
  loadActionType: _actions.CHECKING_ACCOUNT_FILTERS_LOAD,
  failureActionType: _actions.CHECKING_ACCOUNT_FILTERS_FAILURE,
  successActionType: _actions.CHECKING_ACCOUNT_FILTERS_SUCCESS
});
exports.checkingAccountFilters = checkingAccountFilters;

var _default = function _default(state, action) {
  switch (action.type) {
    case _actions.CHECKING_ACCOUNT_FILTERS_LOAD:
    case _actions.CHECKING_ACCOUNT_FILTERS_FAILURE:
    case _actions.CHECKING_ACCOUNT_FILTERS_SUCCESS:
      {
        var newCheckingAccountFilters = checkingAccountFilters(state.checkingAccountFilters, action);
        return state.checkingAccountFilters === newCheckingAccountFilters ? state : {
          checkingAccountFilters: newCheckingAccountFilters
        };
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;

var _createBaseSelectors = (0, _utils.createBaseSelectors)('checkingAccountFilters'),
    getCheckingAccountFiltersSlice = _createBaseSelectors.getSlice,
    getAreCheckingAccountFiltersLoading = _createBaseSelectors.getIsLoading,
    getCheckingAccountFiltersLastError = _createBaseSelectors.getLastError,
    getCheckingAccountFiltersLastSuccess = _createBaseSelectors.getLastSuccess,
    getCheckingAccountFiltersData = _createBaseSelectors.getData,
    getCheckingAccountFiltersError = _createBaseSelectors.getError,
    getHasACheckingAccountFiltersFetchFinished = _createBaseSelectors.getHasAFetchFinished,
    getHasCheckingAccountFiltersLoadedSuccessfully = _createBaseSelectors.getHasLoadedSuccessfully;

exports.getHasCheckingAccountFiltersLoadedSuccessfully = getHasCheckingAccountFiltersLoadedSuccessfully;
exports.getHasACheckingAccountFiltersFetchFinished = getHasACheckingAccountFiltersFetchFinished;
exports.getCheckingAccountFiltersError = getCheckingAccountFiltersError;
exports.getCheckingAccountFiltersData = getCheckingAccountFiltersData;
exports.getCheckingAccountFiltersLastSuccess = getCheckingAccountFiltersLastSuccess;
exports.getCheckingAccountFiltersLastError = getCheckingAccountFiltersLastError;
exports.getAreCheckingAccountFiltersLoading = getAreCheckingAccountFiltersLoading;
exports.getCheckingAccountFiltersSlice = getCheckingAccountFiltersSlice;
var getCheckingAccountFilters = (0, _reselect.createSelector)(getCheckingAccountFiltersData, function (response) {
  var _response$checkingAcc;

  return (_response$checkingAcc = response === null || response === void 0 ? void 0 : response.checkingAccountFilters) !== null && _response$checkingAcc !== void 0 ? _response$checkingAcc : [];
});
exports.getCheckingAccountFilters = getCheckingAccountFilters;
//# sourceMappingURL=reducer.js.map